import { Box, InputLabel, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FC } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { BotContentTextField } from '@/components/custom-form-text-field';
import { NumericRatingBotModuleData } from '@/domain/bot';
import { NodeFormProps } from '@/domain/node-form-props';
import { useSaveBotVersionEnabled } from 'utils/hooks/use-save-bot-version-enabled';

export const RatingScaleBlock: FC<
    NodeFormProps<NumericRatingBotModuleData['params']>
> = ({ control }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const saveEnabled = useSaveBotVersionEnabled();

    return (
        <Box
            sx={{
                border: `solid 3px ${theme.palette.secondary.veryLight}`,
                borderRadius: '10px',
                p: 2,
                marginBottom: '1rem',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                }}
            >
                <Typography variant='cardTitle'>{t('rating_scale')}</Typography>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '10px',
                    alignItems: 'baseline',
                    marginBottom: '10px',
                }}
            >
                <Box>
                    <InputLabel className='input-label-card'>
                        {t('rating_scale_min')}
                    </InputLabel>
                    <Controller
                        name='min'
                        control={control}
                        render={({ field, fieldState: { error } }) => (
                            <BotContentTextField
                                {...field}
                                fieldError={error}
                                type='number'
                                disabled={!saveEnabled}
                            />
                        )}
                    />
                </Box>
                <Box>
                    <InputLabel className='input-label-card'>
                        {t('rating_scale_max')}
                    </InputLabel>
                    <Controller
                        name='max'
                        control={control}
                        render={({ field, fieldState: { error } }) => (
                            <BotContentTextField
                                {...field}
                                fieldError={error}
                                type='number'
                                disabled={!saveEnabled}
                            />
                        )}
                    />
                </Box>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'baseline',
                }}
            >
                <Box sx={{ marginBottom: '10px', width: '100%' }}>
                    <InputLabel className='input-label-card'>
                        {t('prompt_out_of_bounds')}
                    </InputLabel>
                    <Controller
                        name='out_of_bounds_prompt'
                        control={control}
                        render={({ field, fieldState: { error } }) => (
                            <BotContentTextField
                                {...field}
                                fieldError={error}
                                autoResize
                                disabled={!saveEnabled}
                            />
                        )}
                    />
                </Box>
                <Typography>{t('range_variables_info')}</Typography>
            </Box>
        </Box>
    );
};
